import { useEffect, useRef } from 'react';
import styles from './MobileTabBar.module.css';

// Bottom navigation for the mobile shell: a fixed "Laps" button plus one tab
// per enabled panel. Only the active panel is rendered above, so the tabs are
// the sole way to move between panels (no page scroll on mobile).
export default function MobileTabBar({ tabs, activeId, onSelect, onOpenLaps, lapsOpen }) {
  const activeRef = useRef(null);

  // Keep the active tab visible when it changes (e.g. after closing a panel).
  useEffect(() => {
    activeRef.current?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }, [activeId]);

  return (
    <div className={styles.bar}>
      <button
        className={`${styles.lapsBtn} ${lapsOpen ? styles.lapsOpen : ''}`}
        onClick={onOpenLaps}
      >
        Laps
      </button>
      <div className={styles.tabs}>
        {tabs.map((t) => (
          <button
            key={t.id}
            ref={t.id === activeId ? activeRef : null}
            className={`${styles.tab} ${t.id === activeId ? styles.active : ''}`}
            onClick={() => onSelect(t.id)}
          >
            {t.title}
          </button>
        ))}
      </div>
    </div>
  );
}
